/*
* Copyright (C) Regione Lombardia
*/
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import { ProgettoService } from '@shared/services/progetto.service';
import { UtilsService } from '@shared/services/utils.service';

@Component({
    selector: 'app-pages-gestione-progetto-crea-progetto',
    templateUrl: './crea-progetto.component.html',
})
export class PagesGestioneProgettoCreaProgettoComponent implements OnInit{

    public criteriaForm: FormGroup;

    constructor(
        private progettoService: ProgettoService,
        private utilsService: UtilsService,
        private route: ActivatedRoute,
        private router: Router
    ) { }
    
    ngOnInit() {
        this.criteriaForm = this.progettoService.generateFormProgetto();
    }

    public inserisciProgetto() {
        if(this.criteriaForm.get('annoEsecuzione')?.invalid) {
            this.utilsService.showWarning('Inserire un anno valido compreso tra il 1900 e il 2099');
            return;
        } else if (this.criteriaForm.invalid) {
            this.utilsService.showWarning(CoreI18nConfigs.messages.fieldRequired);
            this.criteriaForm.markAllAsTouched();
            return;
        }
         else if(!this.progettoService.isValidCUP(this.criteriaForm.get('cup')?.value)) {
            this.criteriaForm.get('cup')?.setErrors({});
            return;
        }
        this.progettoService.create(this.criteriaForm.getRawValue()).subscribe(response => {
            this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
            this.router.navigate(['..'], { relativeTo: this.route });
        });
    }



}
